import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import NumberCell from '@/onenetwork/components/datatable/NumberCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { FlashOfferAPI } from '../constants/flashoffer.api.uri.const'
import { buildFilterObject } from '@/utils/filter'
import { FO_STATUS, formatTableDataFlashOffer } from '../helper/table'
import {markRaw} from 'vue'


export interface tabItem {
  id: string,
  label: string,
  active: boolean,
}

export enum FlashOfferListActionTypes {
  FILTERING = 'FILTERING',
  PENDING= "PENDING",
  FETCHING= "FETCHING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
  FETCH_FAILURE = "FETCH_FAILURE",
}

interface FlashOfferListStore {
  action_type: FlashOfferListActionTypes,
  action_mess: string,
  uuid: string,
  data: Object,
  filter: Array<{
    key: string,
    type: string,
    label: string,
    placeholder: string,
    value: any,
    options?: Array<{label: string, value: string}>
  }>,
  pageSize: number,
  page: number,
  tabs: Array<any>,
  tableConfig: any,
  selectedIds: Array<string|number>,
}

export const useFlashOfferListStore = defineStore('flash_offer.list', {
  state: (): FlashOfferListStore => ({
    action_type: FlashOfferListActionTypes.PENDING,
    action_mess: "",
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'province_id',
        type: 'region-level-1',
        label: 'Lọc theo tỉnh/thành',
        placeholder: 'Chọn tỉnh / thành',
        value: '',
        options: [],
      },
      {
        key: 'ward_id',
        type: 'region-level-2',
        label: 'Lọc theo phường / xã',
        placeholder: 'Chọn phường xã',
        value: '',
        options: [],
      },
      {
        key: 'name',
        type: 'taginput',
        label: 'Lọc theo tiêu đề',
        placeholder: 'Nhập tiêu đề',
        value: '',
      },
      {
        key: 'status',
        type: 'select-multiple',
        label: 'Lọc theo trạng thái',
        placeholder: 'Chọn trạng thái',
        value: '',
        options: FO_STATUS,
      },
      {
        key: 'end_date',
        type: 'date-range',
        label: 'Lọc theo ngày đăng ký',
        placeholder: 'Chọn ngày đăng ký',
        value: '',
      },
    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Danh sách FlashOffer',
        active: true,
      }
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        id: { label: 'ID', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
        started_at: { label: 'Ngày bắt đầu', component: markRaw(DateTimeCell), class: '', visible: true, sort: '', config: {} },
        ended_at: { label: 'Ngày kết thúc', component: markRaw(DateTimeCell), class: '', visible: true, sort: '', config: {} },
        status_text: { label: 'Trạng thái', component: markRaw(TagCell), class: '', visible: true, sort: false, config: {} },
        name: { label: 'Tên sự kiện', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
        total_items: { label: 'Số lượng mở bán', component: markRaw(NumberCell), class: 'justify-end', visible: true, sort: false, config: {} },
        created_at: { label: 'Ngày đăng ký', component: markRaw(DateTimeCell), class: '', visible: true, sort: 'desc', config: {} },
        created_by: { label: 'Người tạo', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
      }
    },
    selectedIds: []
  }),
  getters: {
    sortFilter: state => {
      const sort: any = []
      if(Object.keys(state.tableConfig?.columns).length>0){
        Object.keys(state.tableConfig?.columns).forEach(col => {
          if(state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    }
  },
  actions: {
    //TAB ACTION
    changeTab (targetId: string) {

      for (const tab of this.tabs) {
        tab.active = (tab.id === targetId)
      }
    },
    closeTab (targetId: string) {
      const index = this.tabs.findIndex(tab => tab.id === targetId)
      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab () {
      this.tabs = [{
        id: 'list',
        label: 'Danh sách FlashOffer',
        active: true,
      }]
    },
    newTab (item: tabItem) {
      const exists = this.tabs.some(tab => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter (filter: any) {
      this.filter = filter
      this.action_type = FlashOfferListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    resetFilter () {
      this.filter = this.filter.map(item => {
        if (item.type === 'region-level-1' || item.type === 'region-level-2') {
          return {...item, value: '', options: []}
        }
        return {...item, value: ''}
      })
      this.page = 1
      this.action_type = FlashOfferListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    changeFilter (key: string, value: any) {
      const filterItem = this.filter.find((item: {key: string}) => item.key === key)
      if (filterItem) {
        filterItem.value = value
        this.action_type = FlashOfferListActionTypes.FILTERING
        this.uuid = uuid.v4()
      }
    },
    putFilter(key: string, value: any) {
      this.filter = this.filter.map((field) => {
        if (field.key === key) {
          return { ...field, value: value }
        }
        return field
      })
    },

    //PAGE ACTION
    changePage (page: number) {
      this.page = page
      this.action_type = FlashOfferListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize (size: number) {
      this.pageSize = size
      this.action_type = FlashOfferListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    setSelectedRow(ids: Array<string|number>) {
      this.selectedIds = ids
    },
    //DATA ACTION
    async fetchList(){
      return new Promise(async (resolve, reject) => {
        try{
          this.action_type = FlashOfferListActionTypes.FETCHING
          const sort = this.sortFilter
          const pagination = {
            page: this.page,
            page_size: this.pageSize,
            sort: sort
          };

          const filter = buildFilterObject(this.filter, pagination);
          const res: any = await APIClient.get(FlashOfferAPI.flashoffer.list, {
            params: filter
          })

          const { data } = res.data;

          this.data = {
            list: formatTableDataFlashOffer(data.data) || [],
            totalRecords: data.total ?? 0,
            totalPage: data.last_page ?? 0
          }
          this.action_type = FlashOfferListActionTypes.FETCH_SUCCESS
          resolve(data);
        } catch (e) {
          this.action_type = FlashOfferListActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    },
    async stopFlashOffer(ids: Array<number>) {
      return new Promise(async (resolve, reject) => {
        try {
          const res: any = await APIClient.post(FlashOfferAPI.flashoffer.stop, {
            flash_offer_ids: ids
          })
          this.selectedIds = [];
          this.fetchList();
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  }
})
